import { toast } from 'sonner'
import { toggleLoader } from '@/hooks/useDashboardLoader.jsx'
import { handleError } from '@/services/errorHandler.js'
import { finishMetaOauthFlow, updateIntegration } from '@/services/api.js'
import { IntegrationProviders } from '@/consts/index.js'
import { useDashboardContext } from '@/context-state/DashboardContext.jsx'
import { useAuthContext } from '@/context-state/AuthContext'
import { useCurrentAccount } from '@/hooks/useCurrentAccount'

// const fbScope = 'ads_management,read_insights,pages_show_list,ads_read,business_management,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_posts'
// I need these - pages_read_user_content,pages_read_engagement


export const useMetaConnection = () => {

    const { integrationsContext } = useDashboardContext()
    const { updateIntegrationsState, updateExistingIntegrationState } = integrationsContext
    const { account } = useCurrentAccount()

    // Test to see if we can leave without the 'business_management' scope
    const fbScope = account.disableBusinessPermission ? 'ads_management,ads_read,pages_show_list,pages_read_engagement' : 'ads_management,ads_read,pages_show_list,pages_read_engagement,business_management'

    const setMetaConnectionAsInActive = async (integrationId) => {
        try {
            toggleLoader(true)
            const { data } = await updateIntegration(integrationId, { reAuthRequire: true })
            updateExistingIntegrationState(integrationId, data)
        } catch (e) {
            console.log(e)
            toast.error(e.message)
            handleError(e)
        } finally {
            toggleLoader(false)
        }
    }

    const connectToMeta = async (existingIntegration) => {
        try {
            toggleLoader(true)
            // ! This won't work on incognito or Dia broswers.
            window.FB.login(function (response) {
                if (response?.status === 'connected') {
                    finishMetaConnection(response.authResponse, existingIntegration)
                    return
                }
                toast.error('Failed to connect to Meta, please try again')
                toggleLoader(false)
            }, { scope: fbScope })

        } catch (e) {
            console.log(e)
            toast.error(e.message)
            handleError(e)
            toggleLoader(false)
        }
    }

    const finishMetaConnection = async (authResponse, existingIntegration) => {
        try {
            toggleLoader(true)
            // exchange the token with a long-lived token.
            // Pass the existing integration id if it exists, so we can update instead of creating a new one
            const newIntegrationResponse = await finishMetaOauthFlow({ ...authResponse, provider: IntegrationProviders.META, scope: fbScope, existingIntegrationId: existingIntegration?._id })
            if (existingIntegration) {
                updateExistingIntegrationState(existingIntegration._id, newIntegrationResponse.data)
                toast.success('Meta reconnected successfully!')
                return
            }
            updateIntegrationsState([newIntegrationResponse.data])
            toast.success('Meta connected successfully!')
        } catch (e) {
            console.log(e)
            toast.error(e.message)
            handleError(e)
        } finally {
            toggleLoader(false)
        }
    }

    return { connectToMeta, setMetaConnectionAsInActive }

}